import React from "react";
import styled from "styled-components";
import { ErrorMessage, FieldValuesFromFieldErrors } from "@hookform/error-message";
import { FieldErrors, FieldName, FieldValues } from "react-hook-form";

const ErrorField = styled.div`
  width: 100%;
  background-color: #f5abba;
  border-radius: 5px;
  padding: 2px 5px;
  color: #6e0218;
`;

type ErrorFieldProps<TFieldErrors extends FieldValues> = {
  errors: FieldErrors<TFieldErrors>;
  name: FieldName<FieldValuesFromFieldErrors<TFieldErrors>>;
};

export function ErrorFieldMessage<TFieldErrors extends FieldValues>({
  errors,
  name,
}: ErrorFieldProps<TFieldErrors>) {
  return (
    <ErrorMessage
      errors={errors}
      name={name}
      render={({ message }) => <ErrorField>{message}</ErrorField>}
    />
  );
}
